module.exports = __webpack_public_path__ + "media/images/top/keisan_print-min-57ece9b83e7777a065d8b1e674313094.png";